import InfoSuriya from "./info-suria";

export default InfoSuriya;